import React, { useState } from 'react';
import { Award, Save, Plus, TrendingUp } from 'lucide-react';
import { KornFerrySkills } from './KornFerrySkills';
import { useToast } from '../../context/ToastContext';
import { Modal } from '../ui/Modal';
interface SkillLevel {
  skillId: number;
  level: number;
  status: 'not-started' | 'in-development' | 'proficient' | 'expert';
}
export function SkillsPage() {
  const {
    showToast
  } = useToast();
  const [mySkills, setMySkills] = useState<number[]>([1, 6, 7, 22, 30]);
  const [skillLevels, setSkillLevels] = useState<SkillLevel[]>([{
    skillId: 1,
    level: 65,
    status: 'proficient'
  }, {
    skillId: 6,
    level: 45,
    status: 'in-development'
  }, {
    skillId: 7,
    level: 80,
    status: 'proficient'
  }, {
    skillId: 22,
    level: 90,
    status: 'expert'
  }, {
    skillId: 30,
    level: 55,
    status: 'proficient'
  }]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [tempSelectedSkills, setTempSelectedSkills] = useState<number[]>([]);
  const handleOpenAddModal = () => {
    setTempSelectedSkills(mySkills);
    setIsAddModalOpen(true);
  };
  const handleSaveSkills = () => {
    setMySkills(tempSelectedSkills);
    setIsAddModalOpen(false);
    showToast('Vos compétences ont été mises à jour', 'success');
  };
  const handleLevelsChange = (newLevels: SkillLevel[]) => {
    setSkillLevels(newLevels);
    showToast('Niveau de compétence mis à jour', 'success');
  };
  return <div className="pb-20 md:pb-0" data-id="element-1493">
      <div className="mb-8" data-id="element-1494">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4" data-id="element-1495">
          <div data-id="element-1496">
            <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1497">
              Compétences Korn Ferry
            </h1>
            <p className="text-gray-600" data-id="element-1498">
              Gérez et développez vos compétences professionnelles
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2" data-id="element-1499">
            <button onClick={handleOpenAddModal} className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 shadow-sm hover:shadow-md transition-all" data-id="element-1500">
              <Plus className="h-5 w-5" data-id="element-1501" />
              Gérer mes compétences
            </button>
          </div>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-1502">
          <div className="flex items-start gap-3" data-id="element-1503">
            <Award className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-1504" />
            <div data-id="element-1505">
              <h3 className="font-semibold text-blue-900 mb-1" data-id="element-1506">
                À propos des compétences Korn Ferry
              </h3>
              <p className="text-sm text-blue-700 leading-relaxed" data-id="element-1507">
                Le modèle Korn Ferry comprend 38 compétences organisées en 4
                catégories : Leadership, Réflexion Stratégique, Résultats et
                Développement Personnel. Sélectionnez les compétences que vous
                souhaitez développer et évaluez votre niveau de maturité.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-1508">
        <div className="mb-6" data-id="element-1509">
          <div className="flex items-center justify-between mb-2" data-id="element-1510">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-1511">
              Mes compétences et niveaux
            </h2>
            <p className="text-sm text-gray-600" data-id="element-1512">
              Cliquez sur une compétence pour ajuster votre niveau
            </p>
          </div>
          <p className="text-sm text-gray-600" data-id="element-1513">
            {mySkills.length} compétence(s) dans votre plan de développement
          </p>
        </div>

        <KornFerrySkills selectedSkills={mySkills} skillLevels={skillLevels} trackedSkills={mySkills} onLevelsChange={handleLevelsChange} onTrackedSkillsChange={setMySkills} mode="view" showTracking={true} data-id="element-1514" />
      </div>

      {/* Modal pour gérer les compétences */}
      <Modal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} title="Gérer mes compétences" size="lg" data-id="element-1515">
        <div className="space-y-4" data-id="element-1516">
          <p className="text-sm text-gray-600" data-id="element-1517">
            Sélectionnez les compétences que vous souhaitez développer. Vous
            pouvez en choisir autant que nécessaire.
          </p>

          <KornFerrySkills selectedSkills={tempSelectedSkills} onSkillsChange={setTempSelectedSkills} mode="select" data-id="element-1518" />

          <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4 border-t" data-id="element-1519">
            <button onClick={() => setIsAddModalOpen(false)} className="w-full sm:w-auto px-6 py-2.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1520">
              Annuler
            </button>
            <button onClick={handleSaveSkills} className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium shadow-sm transition-colors" data-id="element-1521">
              <Save className="h-4 w-4" data-id="element-1522" />
              Enregistrer
            </button>
          </div>
        </div>
      </Modal>
    </div>;
}